import { AppBuilder, EVENTS, ScrollDirection, Wire, WIRES } from '@empathybroker/ebx-gluon';
import { Observable } from 'rxjs';

const hideShowHeader: Wire = (observable: Observable<ScrollDirection>) => {
  const selectorsToTranslate =
    `.ebx-empathy-x__header,
    .ebx-empathy-x--mobile .ebx-empathy-x__toolbar,
    .ebx-empathy-x--mobile .ebx-empathy-x__main,
    .ebx-empathy-x--desktop .ebx-empathy-x__toolbar,
    .ebx-empathy-x--desktop .ebx-empathy-x__main`;

  const selectorsToMeasure =
    `.ebx-empathy-x__header,
    .ebx-empathy-x--mobile .ebx-empathy-x__toolbar,
    .ebx-empathy-x--desktop .ebx-empathy-x__toolbar`;

  observable.subscribe(scrollDirection => {
    const elementsToTranslate = document.querySelectorAll<HTMLElement>(selectorsToTranslate);
    const elementsToMeasure = document.querySelectorAll<HTMLElement>(selectorsToMeasure);
    let translationHeight = 0;
    if (scrollDirection === ScrollDirection.DOWN) {
      elementsToMeasure.forEach(el => {
        const currentHeight = (el as HTMLElement).offsetHeight;
        (el as HTMLElement).style.height = currentHeight + 'px';
        translationHeight += currentHeight;
      });
      const empathize = document.querySelector<HTMLElement>('.ebx-empathize-panel');
      if (empathize) {
        translationHeight -= empathize.clientHeight;
      }
      elementsToTranslate
        .forEach(el => (el as HTMLElement).style.transform = `translateY(-${ translationHeight }px)`);
    } else {
      elementsToMeasure
        .forEach(el => (el as HTMLElement).style.height = '');
      elementsToTranslate
        .forEach(el => (el as HTMLElement).style.transform = '');
    }
  });
};

const fixScrollPosition: Wire = (observable: Observable<void>) => {
  const empathyXSelector = '.ebx-empathy-x.ebx-empathy-x--desktop.ebx-empathy-x--cdl';
  observable.subscribe(() => {
    const empathyX = document.querySelector<HTMLElement>(empathyXSelector);
    if (empathyX) {
      empathyX.scrollTo(0, 0);
    }
  });
};

export const WIRING_CONFIG = (builder: AppBuilder) => {
  builder
    .replaceWireInEvent(WIRES.clearRelatedTags, EVENTS.QueryCleared, WIRES.clearRelatedTags)
    .addWireToEvent(hideShowHeader, EVENTS.ScrollDirectionChanged)
    .addWireToEvent(fixScrollPosition, EVENTS.OpenFinished)
    // Inverting WIRES.trackQuery and WIRES.redirectIfDirect order in EVENTS.SearchSuccess to fix query tagging when redirecting.
    .removeWireFromEvent(WIRES.trackQuery, EVENTS.SearchSuccess)
    .addWireToEventBeforeWire(WIRES.trackQuery, EVENTS.SearchSuccess, WIRES.redirectIfDirect);
};
